export const getFileDataUrl = (file: File | Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = () => resolve(fileReader.result as string);
    fileReader.onerror = () => reject(fileReader.error);
    fileReader.onabort = ev => reject({ eventType: ev.type, error: fileReader.error });
    fileReader.readAsDataURL(file);
  });

export const convertBase64toBlob = (content: any, contentType: string): Blob => {
  contentType = contentType || '';
  const sliceSize = 512;
  const byteCharacters = window.atob(content); // method which converts base64 to binary
  let byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, {
    type: contentType,
  }); // statement which creates the blob
  return blob;
};

export const trimToOnlyBase64 = (base64: string) => base64.replace(/^data:image\/\w+;base64,/, '');
